



















































import { Component, Inject, Prop } from "vue-property-decorator";

import AdminPanel from "@share/common/admin-panel/AdminPanel.vue";
import CardsSectionCommitees from "@share/committees/committees-list/components/cards-section/CardsSectionCommitees.vue";
import SegmentControl from  "@share/common/segment/Segment.vue";
import { EventType } from "@share/common/types/enums/EventType";
import { CommitteeModel } from "@api/models/committees/CommitteeModel";

import { RepositoryFabric } from "@api/repositories/RepositoryFabric";

import { SelectableTagInterface } from "@api/models/interfaces/SelectableTagInterface";
import { Element } from "@api/models/Element";
import { UserProfileService } from "@share/common/services/dataLoading/userProfiles/UserProfilesService";
import { CompanyLoadService } from "@share/common/services/dataLoading/ugmkCompany/CompanyLoadService";
import UserProfileCollector from "@share/committees/common/service-components/UserProfilesCollector.vue";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { UserProfile } from "@api/models/UserProfile";
import { mainActions } from "@service/store/main/actions";
import BounceSpinner from "@share/common/BounceSpinner.vue";

import { QueryParametersInterface } from "@api/repositories/interfaces/QueryParametersInterface";
import { AgendaDistributer, DistributedItems } from "@share/program/helpers/agendaDistribution";
import { DateTime } from "luxon";
import { getDates } from "@share/program/helpers/dates";
import { committeeConverter } from "@api/models/objects/Converters";

@Component({ components: { AdminPanel, CardsSectionCommitees, SegmentControl, BounceSpinner } })

export default class CommitteesList extends UserProfileCollector {
    //COMMON:
    @Prop() activeSectionType: EventType;
    @Inject() setActiveSectionType!: (value: EventType) => void;

    private readonly COMMITTEES_SCHEMA_ID = "Committees";

    tags: SelectableTagInterface[] | null = null;
    companyLoadService: CompanyLoadService | null = null;
    companyLoading = false;

    upcomingCount = 0;
    pastCount = 0;

    async created() {
        this.userProfileService = new UserProfileService(
            this.$repositories.get(RepositoryFabric.USER),
            ["id", "userId", "lastName", "firstName", "photoFileId", "company", "position"]
        );

        this.companyLoadService = new CompanyLoadService(
            this.$repositories.get<ObjectRepository>(RepositoryFabric.OBJECT)
        );

        try {
            this.companyLoading = true;
            this.$store.dispatch(mainActions.setCurrentUserCompanyId, (await this.companyLoadService.getCompanyByChildId(this.currentUserProfile.directionId))?.id || "");

            this.getAllCommittees();
        }
        catch(e) {
            this.$store.dispatch('reportError', e);
        }
        finally {
            this.companyLoading = false;
        }
    }

    /**
     * get all committees and set past and upcoming count;
     * it need for showSegments flag
     */
    async getAllCommittees() {
        const query: QueryParametersInterface = {
            include: ['beginAt', 'endAt'],
            where: {
                $or: [
                    {
                        ownerIds: { $containsAny: [this.currentUserId] }
                    },
                    {
                        userIds: { $containsAny: [this.currentUserId] }
                    },
                    (this.currentUserCompanyId ? { company: this.currentUserCompanyId } : null)
                ]
            },
            take: -1
        };

        const objectRepository = this.$repositories.get<ObjectRepository>(RepositoryFabric.OBJECT);

        const committees = await objectRepository.query(
            this.COMMITTEES_SCHEMA_ID,
            query,
            committeeConverter
        );

        const { dayStart, dayEnd } = getDates(DateTime.local());
        let distributedCommittees: DistributedItems<Element> | null = AgendaDistributer.distribute(committees, dayStart, dayEnd, false);

        this.pastCount = distributedCommittees.past.length;
        this.upcomingCount = distributedCommittees.future.length;

        //clear
        distributedCommittees = null;
    }

    get currentUserCompanyId() {
        return this.$store.state.currentUserCompanyId
    }

    get currentUserProfile(): UserProfile {
        return this.$store.state.session.profile;
    }

    get currentUserId() {
        return this.$store.state.session.userId as number;
    }

    async loadTags() {

        const tags = await this.$store.dispatch("tags/loadTags", { condition: {}, schemaId: "Tags" }) as Element[] | null;

        this.tags = tags?.map((tag) => {
            return {
                tag: Object.freeze({ id: tag.id, title: tag.title }),
                isVisible: true,
                isSelected: false
            }
        }) || [];
    }

    goToCreate() {
        this.$router.push({
            name: RouteNamesEnum.committeesCreate,
        })
        .catch((r) => {r})
    }

    //COMMON:
    changeType(value: EventType) {
        this.setActiveSectionType(value);
    }

    openCommittee(committee: CommitteeModel) {
        this.$emit("open", committee);
    }

    editCommittee(committee: CommitteeModel) {
        this.$emit("edit", committee);
    }

    private get showUpcoming() {
        return this.showSegment ? this.activeSectionType === EventType.upcoming && !!this.upcomingCount : !!this.upcomingCount;
    }

    private get showPast() {
        return this.showSegment ? this.activeSectionType === EventType.past && !!this.pastCount : !!this.pastCount;
    }

    get segmentData()  {
        return [{
            active: this.activeSectionType === EventType.upcoming,
            title: this.$t('common.upcoming'),
            value: EventType.upcoming
        },
        {
            active: this.activeSectionType === EventType.past,
            title: this.$t('common.past'),
            value: EventType.past
        }]
    }

    get backend() {
        return this.$store.state.session.backend;
    }

    get isOnEditing() {
        return this.$store.state.isOnEditing;
    }

    private get showSegment() {
        //there are upcoming and past sessions
        return !!this.upcomingCount && !!this.pastCount;
    }
}

